import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_INTERFACE} from '../../metamodel/Concept';

export default class TechnologyInterfaceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_INTERFACE;
	}
}
